import { RoundedButton as UIRoundedButton } from 'flicket-ui';
import styled from 'styled-components';

export const RoundedButton = styled(UIRoundedButton)`
  box-shadow: 0px 9px 6px rgba(0, 0, 0, 0.05),
    0px 2.01027px 8.71116px rgba(0, 0, 0, 0.0774939),
    0px 0.598509px 2.59354px rgba(0, 0, 0, 0.0525061);
`;
